"use client";

import styles from "@/styles/modules/components/homepage/module3.module.scss";
import { HomepageOptions } from "@/types/wordpress";
import Content from "../Content";
import { ContentComponent } from "@/types/modules";
import { useContext, useEffect, useState } from "react";
import { LanguageContext } from "@/context/languageContext";

interface Module3Props {
  homepageOptions: HomepageOptions;
}

export default function Module3({ homepageOptions }: Module3Props) {
  const { language } = useContext(LanguageContext);
  const [data, setData] = useState(
    language === "en" ? homepageOptions.module3 : homepageOptions.module3DE
  );

  useEffect(() => {
    setData(
      language === "en" ? homepageOptions.module3 : homepageOptions.module3DE
    );
  }, [homepageOptions.module3, homepageOptions.module3DE, language]);

  const content: ContentComponent = {
    imageAlign: data.contentFields.imageAlign,
    textAlign: data.contentFields.textAlign,
    content: data.contentFields.body,
    gallery: data.contentFields.gallery,
    sameWidth: true,
    button: data.contentFields.button,
    ...(data.contentFields.title && {
      title: data.contentFields.title,
    }),
  };

  return (
    <section
      className={styles.module3}
      style={{
        backgroundColor:
          homepageOptions.module3.backgroundColor.backgroundColor || "",
        ["--section-color" as any]:
          homepageOptions.module3.backgroundColor.backgroundColor || "",
      }}
    >
      <div className={styles.module3Container} data-aos="fade-in">
        <Content content={content} />
      </div>
    </section>
  );
}
